export default {
    notifications(state){
        return state.notifications
    },
    unreadNotifications(state){
        return state.unreadNotifications
    },
    loading(state){
        return state.loading
    },
    bellLoading(state){
        return state.bellLoading
    },
    config(state) {
        return state.config
    },
    total(state) {
        return state.total
    },
    pages(state) {
        return state.pages
    }
}
